import { API_ENDPOINTS } from "@/api/services/helpdesk/apiEndPoint";
import { myRequestApi } from "./MyRequestApi";
import { myTicketApi } from "./MyTicketApi";
import { baseApi } from "@/utils/baseApi";

export const raiseTicketApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    postRaiseTicket: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.RAISETICKET.RAISE_TICKET,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "raiseTicket", id: "LIST" }],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(myRequestApi.util.invalidateTags(["myRequest"]));
          dispatch(myTicketApi.util.invalidateTags(["myTicket"]));
        } catch (error) {
          // console.error("approveRegularization failed:", error);
        }
      },
    }),
    fetchRaiseTicketMenuList: builder.query({
      query: (menuId) => ({
        url: API_ENDPOINTS.RAISETICKET.MENU_LIST(menuId),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      // providesTags: [{ type: "raiseTicket", id: "LIST" }],
    }),
    fetchCategoryList: builder.query({
      query: () => ({
        url: API_ENDPOINTS.RAISETICKET.CATEGORY_LIST,
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      // providesTags: [{ type: "raiseTicket", id: "LIST" }],
    }),

    // api for HR
  }),
});

export const {
  usePostRaiseTicketMutation,
  useFetchRaiseTicketMenuListQuery,
  useFetchCategoryListQuery,
} = raiseTicketApi;
